<template>
    <div id="administrator-candidatures">
        <b-overlay :show="showLoading" spinner-variant="primary">
            <b-card>
                <ag-grid :agGrid="agGrid" pageTitle="Candidatures (Recrutement)" @refresh="loadData" />
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import AgGrid from "@/views/components/ag-grid/AgGrid.vue"

export default {
    components: { AgGrid },
    data() {
        return {
            showLoading: false,
            agGrid: {
                columnDefs: [
                    { headerName: "Date",    field: "createdAt", width: 160 },
                    { headerName: "Nom",     field: "fullName",  flex: 1 },
                    { headerName: "Email",   field: "email",     flex: 1 },
                    { headerName: "Tél.",    field: "phone",     width: 140 },
                    { headerName: "Poste",   field: "poste",     width: 160 },
                    { headerName: "Message", field: "message",   flex: 2 },
                ],
                rows: [],
            },
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        async loadData() {
            this.showLoading = true;
            const response = await this.$http.get('public/candidature').catch(() => { this.showLoading = false; });
            if (!response || !response.data) { this.agGrid.rows = []; this.showLoading = false; return; }
            this.agGrid.rows = [...response.data].reverse();
            this.showLoading = false;
        },
    },
}
</script>
